export default {
  name: {
    id: 'rm_metal_potassium_name',
    defaultMessage: 'Potassium',
  },
  smartphoneLabel: {
    id: 'rm_metal_potassium_smartphone_label',
    defaultMessage: 'Low (about a grain of rice)',
  },
  whatItDoesText: {
    id: 'rm_metal_potassium_what_it_does',
    defaultMessage:
      'Potassium compounds are used to create shatter-resistant display glass, such as Gorilla Glass. Potassium ions replace smaller sodium ions at the glass surface, creating compressive stress that makes screens more resistant to cracks.',
  },
  extractionText1: {
    id: 'rm_metal_potassium_extraction_p1',
    defaultMessage:
      'Potassium is extracted from potash ores such as sylvite and carnallite using deep underground or solution-mining methods. Flotation, crystallisation or evaporation then concentrate the ore and produce purified potassium salts. Some of these salts are used in industrial glassmaking. During manufacture, display glass is immersed in a molten potassium-salt bath. Larger potassium ions replace smaller sodium ions at the surface. As the glass cools, this creates compressive stress, hardening the glass.',
  },
  quickFactText: {
    id: 'rm_metal_potassium_quick_fact',
    defaultMessage:
      'Potassium compounds play a hidden role in consumer tech by helping strengthen display glass and improve its resistance to cracks.',
  },
  envSummaryText: {
    id: 'rm_metal_potassium_env_summary',
    defaultMessage:
      'Potash mining uses water and energy and creates salty wastewater, called brine, as well as waste rock and tailings. It can cause ground subsidence and increase salt levels in soil and water. These impacts may damage freshwater ecosystems, vegetation and nearby habitats.',
  },
  envWaterText: {
    id: 'rm_metal_potassium_env_water_text',
    defaultMessage:
      'Potash mining can use significant amounts of water. Salty wastewater and mining waste may release salts into rivers, groundwater and soil, reducing water quality and affecting freshwater ecosystems and nearby communities. The impact depends on the mining method and waste-management practices.',
  },
  envSoilText: {
    id: 'rm_metal_potassium_env_soil_text',
    defaultMessage:
      'Mining can disturb soil and, in underground operations, cause the ground above abandoned areas to sink. Salt from mining waste and processing can build up in surrounding soils, reducing soil quality and harming vegetation. Near some potash mines, floodplain soils can show sodium, potassium and chloride concentrations 7 to 10 times higher than background levels.',
  },
  envBiodiversityText: {
    id: 'rm_metal_potassium_env_biodiversity_text',
    defaultMessage:
      'Salt pollution can reduce the number and variety of species in freshwater ecosystems and damage nearby habitats. The long-term effects on biodiversity are not fully understood, but careful management of mining waste and wastewater can reduce these risks.',
  },
  humanSummaryText: {
    id: 'rm_metal_potassium_human_summary',
    defaultMessage:
      'Potash mining can expose workers to underground accidents, dust, heavy machinery and ground subsidence. Changes in water salinity and pollution may also affect nearby communities and agricultural land. Some potassium compounds are corrosive or reactive and are regulated under EU chemical-safety rules. However, the sources provide no broader assessment of labour rights or community protections in the potash supply chain.',
  },
  geoSummaryText: {
    id: 'rm_metal_potassium_geo_summary',
    defaultMessage:
      'Potash supply is highly concentrated: Canada, Russia, Belarus, China and Germany account for approximately 85% of global mine production. Although Germany provides around 65% of EU potash demand, the European Union still relies on external suppliers for approximately 10% of its potash needs. Past supply disruptions, high energy costs and geopolitical tensions have driven sharp price increases, highlighting potash’s strategic importance. These figures refer to potash compounds, not potassium metal.',
  },
  geoDugText: {
    id: 'rm_metal_potassium_geo_dug_text',
    defaultMessage:
      'Canada is the largest producer, accounting for around 31%, followed by Russia at nearly 20%, Belarus at nearly 15%, China at around 13% and Germany at over 6%. These five countries together produced approximately 85% of the global total. The figures refer to potash mine production, not potassium metal.',
  },
  geoProcessedText: {
    id: 'rm_metal_potassium_geo_processed_text',
    defaultMessage:
      'Potash is generally processed close to the mines into products such as potassium chloride and potassium sulfate. The sources do not provide a separate global, country-level breakdown of processing for elemental potassium.',
  },
  geoLeverageText: {
    id: 'rm_metal_potassium_geo_leverage_text',
    defaultMessage:
      'The concentration of potash production gives Canada, Russia, Belarus and China influence over global supply and prices. Prices rose by approximately 64%, from about USD 1,100 per tonne in 2021 to nearly USD 1,800 per tonne in 2022, amid supply disruptions, high energy costs and geopolitical tensions affecting major producers. Brazil, India, China and other large agricultural markets are particularly exposed because they rely heavily on potash imports.',
  },
  supplySummaryText: {
    id: 'rm_metal_potassium_supply_summary',
    defaultMessage:
      'The global potash market is projected to grow by approximately 4% to 6% per year through 2030-2035. A supply surplus of around 13% to 14% of production capacity is expected to remain through 2029, while new projects in Canada, the United Kingdom, Brazil and Gabon could diversify supply.',
  },
  supplyReservesText: {
    id: 'rm_metal_potassium_supply_reserves_text',
    defaultMessage:
      'Total recoverable potash ore reserves exceed 10 billion tonnes, including approximately 4.5 billion tonnes in Canada and 330 million tonnes in Belarus. Reserve estimates for several other countries are unavailable. These figures concern potash ore, not potassium metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_potassium_supply_demand_text',
    defaultMessage:
      'Approximately 92% of potash is used in fertilisers, so demand is mainly linked to agriculture, food production and soil fertility. The glass industry is a major non-fertiliser consumer of potash-derived compounds, which are used in optical glass, screens and specialty ceramics to improve clarity, strength and durability. Glass manufacturing accounts for around 20% of global potassium carbonate demand.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_potassium_recycling_summary',
    defaultMessage:
      'Potash is produced almost exclusively through primary extraction. No reliable data are available on potassium recovery from smartphones or consumer-electronics waste. Potassium compounds in glass recycling streams are generally present in concentrations too low to be recovered economically.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_potassium_recycling_outlook_text',
    defaultMessage:
      'Not currently. No economically viable process has been documented for recovering potassium from glass or consumer electronics. Potassium used in fertilisers is dispersed through soils and crops, making recovery difficult. Manure, sewage sludge, food waste and wood ash can provide supplementary potassium, but their availability and nutrient content are limited. These sources cannot yet replace conventional potash production.',
  },
  footnote1Text1: {
    id: 'rm_metal_potassium_footnote_1_p1',
    defaultMessage:
      'As Potassium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
} as const
